module.exports = __webpack_public_path__ + "static/images-intro-a151a3e104159044ee3dd14c141a58b8.jpg";